import React, { useState } from 'react';
import theme from './FileUploadUnitDocuments.module.scss';
import { useAsyncState, useIsSeller } from '@/utils/hooks';
import { searchFullBuyerDocuments } from '@/services/buyer-dashboard';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { searchResidentialUnitDocuments } from '@/services/documents';
import { Trans } from '@lingui/react/macro';
import { BuyerResidentialUnitDocument, ResidentialUnitDocument } from '@/types';
import DocumentSelectList from '@/components/DocumentSelectList';
import { SlideToggle } from '@ygtechnologies/rubus-ui';

interface FileUploadUnitDocumentsProps {
    residentialUnitId: number;
    onSelect(versionId: number): void;
    selectedVersionId: number | null;
}

const FileUploadUnitDocuments: React.FC<FileUploadUnitDocumentsProps> = ({
    residentialUnitId,
    onSelect,
    selectedVersionId,
}) => {
    const [showHiddenFromBuyer, setShowHiddenFromBuyer] = useState(false);
    const [showSensitive, setShowSensitive] = useState(false);
    const isSeller = useIsSeller();
    const [documents] = useAsyncState<ResidentialUnitDocument[] | BuyerResidentialUnitDocument[] | null>(
        () =>
            isSeller
                ? (searchResidentialUnitDocuments({
                      residentialUnitIds: [residentialUnitId],
                  }) as any)
                : searchFullBuyerDocuments(residentialUnitId),
        [residentialUnitId, showHiddenFromBuyer, showSensitive],
        null
    );

    if (!documents) {
        return <LoadingIndicator />;
    }

    let filteredDocuments = documents;
    if (isSeller) {
        filteredDocuments = (documents as ResidentialUnitDocument[]).filter((d) => {
            if (!showHiddenFromBuyer && d.hideFromBuyer) {
                return false;
            }
            if (!showSensitive && d.isSensitive) {
                return false;
            }
            return true;
        });
    }

    return (
        <>
            <div className={theme.documentContainer}>
                <DocumentSelectList
                    documents={filteredDocuments}
                    mode="version"
                    value={selectedVersionId}
                    onSelectionChange={(value) => onSelect(value as number)}
                />
                {/* {filteredDocuments.length === 0 && <EmptyListMessage />}
                {(filteredDocuments as any).map((d) => (
                    <DocumentListItem
                        key={d.documentId}
                        onSelect={onSelect}
                        selectedVersionId={selectedVersionId}
                        mode="UploadWizard"
                        document={d}
                    />
                ))} */}
            </div>
            {isSeller && (
                <div className={theme.bottomSection}>
                    <SlideToggle checked={showHiddenFromBuyer} onChange={() => setShowHiddenFromBuyer(!showHiddenFromBuyer)}>
                        <Trans>Show hidden from buyer documents</Trans>
                    </SlideToggle>
                    <SlideToggle checked={showSensitive} onChange={() => setShowSensitive(!showSensitive)}>
                        <Trans>Show sensitive documents</Trans>
                    </SlideToggle>
                </div>
            )}
        </>
    );
};

export default FileUploadUnitDocuments;
